var map = {
	"./": 6517,
	"./development": 84617,
	"./development.js": 84617,
	"./index": 6517,
	"./index.js": 6517,
	"./production": 52212,
	"./production.js": 52212,
	"./staging": 68413,
	"./staging.js": 68413
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67365;